import {
  Flex,
  FlexItem,
  Title,
  TextContent,
  TextList,
  TextListVariants,
  TextListItem,
  TextListItemVariants,
} from '@patternfly/react-core'
import * as React from 'react'

import type { InteractionCommunicationConsent } from '@app/domain/visit/visit.interface'
import { formatDateTime } from '@app/lib/time'

interface ICommunicationConsentCardProps {
  communicationConsent: InteractionCommunicationConsent
}

const CommunicationConsentSummaryCard: React.FC<ICommunicationConsentCardProps> = ({
  communicationConsent,
}) => {
  return (
    <Flex direction={{ default: 'column' }}>
      <FlexItem>
        <Flex>
          <FlexItem>
            <Title headingLevel="h2" size="lg">
              Communication Consent
            </Title>
          </FlexItem>
        </Flex>
      </FlexItem>
      <FlexItem>
        <TextContent>
          <TextList component={TextListVariants.dl}>
            <TextListItem component={TextListItemVariants.dt}>
              Accepted:
            </TextListItem>

            <TextListItem component={TextListItemVariants.dd}>
              {communicationConsent.didConsent ? 'Yes' : 'No'}
            </TextListItem>
            <TextListItem component={TextListItemVariants.dt}>
              Updated At:
            </TextListItem>
            <TextListItem component={TextListItemVariants.dd}>
              {formatDateTime(communicationConsent.updatedAt)}
            </TextListItem>
          </TextList>
        </TextContent>
      </FlexItem>
    </Flex>
  )
}

export { CommunicationConsentSummaryCard }
